import axios from 'axios'

export interface SellerScreenOption {name: string; label: string}
export interface SellerSupplierOption {supplier_id: number; fornecedor: string}
export interface SellerUserOptions {screens: SellerScreenOption[]; industries: string[]; cnpjs: string[]; suppliers: SellerSupplierOption[]}

export interface SellerAccountUser {
  seller_user_id: number
  id_user: number
  account_role: 'owner' | 'member'
  name: string
  email: string
  is_actived: boolean
  can_manage_users: boolean
  all_industries: boolean
  all_cnpjs: boolean
  all_suppliers: boolean
  screens: string[]
  industries: string[]
  cnpjs: string[]
  suppliers: number[]
  created_at: string
  updated_at: string
  created_by_name?: string | null
}

export interface SellerUserPayload {
  name: string
  email?: string
  is_actived: boolean
  screens: string[]
  all_industries: boolean
  industries: string[]
  all_cnpjs: boolean
  cnpjs: string[]
  all_suppliers: boolean
  suppliers: number[]
}

interface Envelope<T> {success: boolean; data: T; error?: string}

function dataOrThrow<T>(response: {data: Envelope<T>}): T {
  if (!response.data.success) throw new Error(response.data.error || 'Não foi possível concluir a operação.')
  return response.data.data
}

export async function getSellerUsers(): Promise<SellerAccountUser[]> {
  return dataOrThrow(await axios.get<Envelope<SellerAccountUser[]>>('/sellers/users'))
}

export async function getSellerUserOptions(): Promise<SellerUserOptions> {
  return dataOrThrow(await axios.get<Envelope<SellerUserOptions>>('/sellers/users/options'))
}

export async function createSellerUser(payload: SellerUserPayload): Promise<void> {
  dataOrThrow(await axios.post<Envelope<{seller_user_id: number}>>('/sellers/users', payload))
}

export async function updateSellerUser(sellerUserId: number, payload: SellerUserPayload): Promise<void> {
  const response = await axios.put<Envelope<unknown>>(`/sellers/users/${sellerUserId}`, payload)
  if (!response.data.success) throw new Error(response.data.error || 'Não foi possível salvar o usuário.')
}
